import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants";

const translation = {
  consentModal: {
    title: "کوکی اطلاع",
    description:
      "ہم لازمی کوکیز استعمال کرتے ہیں تاکہ یہ ویب سائٹ درست طریقے سے کام کرے۔ ہم اختیاری ٹریکنگ کوکیز بھی استعمال کرتے ہیں تاکہ ہمیں سمجھنے میں مدد ملے کہ آپ ہماری ویب سائٹ کے ساتھ کیسے تعامل کرتے ہیں۔ یہ اختیاری کوکیز صرف آپ کی اجازت سے لگائی جائیں گی۔",
    acceptAllBtn: "سب قبول کریں",
    acceptNecessaryBtn: "سب مسترد کریں",
    showPreferencesBtn: "انفرادی ترجیحات کا انتظام کریں",
  },
  preferencesModal: {
    title: "کوکی ترجیحات کا انتظام",
    acceptAllBtn: "سب قبول کریں",
    acceptNecessaryBtn: "سب مسترد کریں",
    savePreferencesBtn: "موجودہ انتخاب قبول کریں",
    closeIconLabel: "ونڈو بند کریں",
    sections: [
      {
        title: "کوکی کا استعمال",
        description:
          "ہم اس ویب سائٹ کے بنیادی افعال کی حمایت اور آپ کے براؤزنگ کے تجربے کو بہتر بنانے کے لیے کوکیز استعمال کرتے ہیں۔",
      },
      {
        title: "سخت ضروری کوکیز",
        description: "یہ کوکیز ویب سائٹ کے صحیح کام کرنے کے لیے ضروری ہیں، مثلاً صارف کی توثیق۔",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: { name: "نام", domain: "سروس", description: "تفصیل", expiration: "اختتام" },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description: "کوکی ڈیجیٹل کمیونٹی پلیٹ فارم کی جانب سے صارف کی توثیق کے لیے سیٹ کی گئی۔",
              expiration: "سیشن",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description: "کوکی ڈیجیٹل کمیونٹی پلیٹ فارم کی جانب سے صارف کی توثیق کے لیے سیٹ کی گئی۔",
              expiration: "سیشن",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "یہ کوکی انسانوں اور روبوٹس میں فرق کرنے کے لیے استعمال ہوتی ہے تاکہ ویب سائٹ کو خودکار غلط استعمال سے بچایا جا سکے۔ کوئی ذاتی معلومات جمع نہیں کی جاتیں۔",
              expiration: "۳۰ منٹ",
            },
          ],
        },
      },
      {
        title: "تجزیات",
        description:
          "تجزیات کے لیے استعمال ہونے والی کوکیز ڈیٹا اکٹھا کرنے میں مدد دیتی ہیں جو خدمات کو یہ سمجھنے میں مدد دیتی ہیں کہ صارفین کسی خاص خدمت کے ساتھ کیسے تعامل کرتے ہیں۔ یہ معلومات مواد کو بہتر بنانے اور صارف کے تجربے کو بہتر بنانے والی بہتر خصوصیات بنانے میں مدد دیتی ہیں۔",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: { name: "نام", domain: "سروس", description: "تفصیل", expiration: "اختتام" },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'کوکی <a href="https://business.safety.google/adscookies/">Google Analytics</a> کی جانب سے سیٹ کی گئی',
              expiration: "12 دن بعد ختم",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'کوکی <a href="https://business.safety.google/adscookies/">Google Analytics</a> کی جانب سے سیٹ کی گئی',
              expiration: "سیشن",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel = "تجزیات سے متعلق اسٹوریج کو چالو کرتا ہے، مثلاً دورے کی مدت۔";

export { translation, servicesLabel };
